import React, { useState } from "react";
import Popup from "reactjs-popup";
import "../../TeamManager/styles/teamManagerStyles.css";
import SettingsPageWrapper from "../../../shared/SettingsPageWrapper";
import { updateTeamSetting } from "../../../shared/api/team";
import TrashIcon from "../../shared/Icons/TrashIcon";
import PlusIcon from "../../shared/Icons/PlusIcon";
import XCloseIcon from "../../shared/Icons/XCloseIcon";
import deleteModalContentStyle from "../../../shared/deleteModalContentStyle";

const SettingsAssetsDetails = ({ team, settingsPath, lastEditedAt, changelogVersions }) => {
  const [folderNames, setFolderNames] = useState(team.default_folder_names || []);

  const handleSave = (updatedNames) => {
    const filtered = updatedNames.filter(name => name.trim() !== "");
    updateTeamSetting(team.id, { default_folder_names: filtered });
  };

  const handleFolderChange = (index, value) => {
    setFolderNames(folderNames.map((name, i) => i === index ? value : name));
  };

  const handleDeleteFolder = (index) => {
    const updated = folderNames.filter((_, i) => i !== index);
    setFolderNames(updated);
    handleSave(updated);
  };

  const handleAddFolder = (e) => {
    e.preventDefault();
    setFolderNames([...folderNames, ""]);
  };

  return (
    <SettingsPageWrapper settingsPath={settingsPath} title="Assets" lastEditedAt={lastEditedAt} changelogVersions={changelogVersions}>
      <div className="team-member-card">
        <div className="team-member-card-header">
          <div className="team-member-card-header-left">
            <div className="team-member-card-title-row">
              <h2 className="team-member-card-title">Assets</h2>
            </div>
            <p className="team-member-card-subtitle">
              Manage Assets and Settings.
            </p>
          </div>
        </div>
        <hr style={{ margin: 0, border: 'none', borderTop: '1px solid var(--sl-border-secondary)' }} />

        <div style={{ padding: '32px 24px' }}>
          <div>
            <p className="mb-1 text-dark" style={{ fontSize: 16 }}>
              <strong>Default Asset Folders</strong>
            </p>
            <p className="m-0 small text-muted">
              Customize the default folders that are created for each new event.
            </p>
          </div>
          <div className="table-responsive">
            <table className="table table-sm table-borderless vertical-middle asset-folders-table" style={{ marginTop: 20 }}>
              <thead>
                <tr>
                  <th style={{ fontWeight: 'normal', paddingBottom: 10, width: 200 }}>Folder Name</th>
                  <th>&nbsp;</th>
                </tr>
              </thead>
              <tbody>
                {folderNames.map((folderName, index) => (
                  <tr key={index}>
                    <td style={{ paddingLeft: 0 }}>
                      <input
                        type="text"
                        className="form-control form-control-sm w-100"
                        style={{ borderRadius: "8px" }}
                        value={folderName}
                        onChange={(e) => handleFolderChange(index, e.target.value)}
                        onBlur={() => handleSave(folderNames)}
                      />
                    </td>
                    <td className="text-left">
                      <Popup
                        trigger={
                          <a
                            href="#"
                            aria-label="Delete folder"
                            className="ml-2"
                            style={{ color: 'var(--od-c-b3b3b3, #b3b3b3)' }}
                            onClick={(e) => e.preventDefault()}
                          >
                            <TrashIcon width="16" height="16" />
                          </a>
                        }
                        onOpen={(e) => { e.preventDefault(); }}
                        modal
                        contentStyle={deleteModalContentStyle}
                        closeOnDocumentClick
                      >
                        {close => (
                          <div>
                            <div className="row">
                              <div className="col">
                                <div className="row">
                                  <div className="col">
                                    <h5 style={{ marginBottom: "16px" }}>
                                      <strong>Delete folder?</strong>
                                    </h5>
                                  </div>
                                  <div className="col-xs-auto">
                                    <a
                                      href="#"
                                      aria-label="Close"
                                      className="text-dark"
                                      style={{ paddingRight: "15px" }}
                                      onClick={(e) => { e.preventDefault(); close(); }}
                                    >
                                      <XCloseIcon width="16" height="16" />
                                    </a>
                                  </div>
                                </div>
                                <p>You're about to delete this default folder.</p>
                                <p>This will not affect folders on existing events.</p>
                                <p>Are you sure?</p>
                                <div className="text-right d-flex justify-content-end" style={{ gap: 12 }}>
                                  <button
                                    type="button"
                                    className="team-btn-secondary"
                                    onClick={(e) => { e.preventDefault(); close(); }}
                                  >
                                    Cancel
                                  </button>
                                  <button
                                    type="button"
                                    className="team-btn-danger"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      close();
                                      handleDeleteFolder(index);
                                    }}
                                  >
                                    Delete
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </Popup>
                    </td>
                  </tr>
                ))}
                <tr>
                  <td style={{ paddingLeft: 0 }}>
                    <button
                      type="button"
                      onClick={handleAddFolder}
                      className="team-btn-secondary"
                    >
                      <PlusIcon width="16" height="16" />
                      <span>Add Folder</span>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </SettingsPageWrapper>
  );
};

export default SettingsAssetsDetails;
